import { css } from 'styled-components';
import type { ColorSchemeTypes } from '../../../components/ColorSchemeWrapper';
import {
  standardColorScheme,
  redColorScheme,
  orangeColorScheme,
  pinkColorScheme,
  greenColorScheme,
  purpleColorScheme,
  yellowColorScheme,
  blueColorScheme,
  warningColorScheme,
  errorColorScheme,
  infoColorScheme,
  successColorScheme,
  vendorHubspotColorScheme,
  vendorPardotColorScheme,
  vendorMarketoColorScheme,
  navColorScheme,
} from '../../../css/designTokens/colorSchemes';
import { baseAliasTokens } from '../../../css/designTokens/colorAlias';

const colorSchemes = {
  standard: standardColorScheme,
  blue: blueColorScheme,
  green: greenColorScheme,
  red: redColorScheme,
  yellow: yellowColorScheme,
  purple: purpleColorScheme,
  orange: orangeColorScheme,
  pink: pinkColorScheme,
  error: errorColorScheme,
  info: infoColorScheme,
  success: successColorScheme,
  warning: warningColorScheme,
  'vendor-hubspot': vendorHubspotColorScheme,
  'vendor-marketo': vendorMarketoColorScheme,
  'vendor-pardot': vendorPardotColorScheme,
  nav: navColorScheme,
};

export const getColorScheme = (colorScheme: ColorSchemeTypes | 'nav') => {
  if (colorScheme === 'inherit') {
    return null;
  }

  if (colorScheme === 'nav') {
    return css`
      ${navColorScheme}
    `;
  }

  return css`
    ${colorSchemes[colorScheme]}
    ${baseAliasTokens}
  `;
};
